(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
  this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  if (this.searchModal) {
    this.searchModal.close(false);
  }
}
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const track = document.querySelector('.slider-track');
  const originalSlides = Array.from(document.querySelectorAll('.slide-item'));
  const dots = document.querySelectorAll('.dot');
  const textElement = document.getElementById('press-slider-text');
  const prevBtn = document.querySelector('.arrow-prev');
  const nextBtn = document.querySelector('.arrow-next');
  const totalBlocks = originalSlides.length;
  if (totalBlocks <= 1) {
    track.style.display = "flex";
    track.style.justifyContent = "center";
    track.style.transform = "none";
    originalSlides[0].classList.add("active-slide");
    document.querySelector(".simple-slider-nav").style.display = "none";
    return;
  }
  originalSlides.forEach(slide => {
    const cloneBefore = slide.cloneNode(true);
    cloneBefore.classList.add('clone');
    track.insertBefore(cloneBefore, track.secondChild);
  });
  originalSlides.forEach(slide => {
    const cloneAfter = slide.cloneNode(true);
    cloneAfter.classList.add('clone');
    track.appendChild(cloneAfter);
  });
  const allSlides = Array.from(document.querySelectorAll('.slide-item'));
  const originalCount = originalSlides.length;
  let currentIndex = originalCount; 
  let isTransitioning = false;
  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;
  function updateSlider(withTransition = true) {
    if (withTransition) {
      track.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
    } else {
      track.style.transition = 'none';
    }
    const slideWidth = allSlides[0].offsetWidth;
    const containerWidth = document.querySelector('.simple-slider').offsetWidth;
    const centerOffset = (containerWidth / 2) - (slideWidth / 2);
    currentTranslate = -(currentIndex * slideWidth) + centerOffset;
    prevTranslate = currentTranslate;
    setSliderPosition();
    allSlides.forEach((slide, index) => {
      slide.classList.remove('active-slide');
      const logo = slide.querySelector('.press-logo');
      if(logo) logo.style.opacity = "0.5"; 
      if (index === currentIndex) {
        slide.classList.add('active-slide');
        if(logo) logo.style.opacity = "1";   
        const text = slide.dataset.text;
        if (text) {
    textElement.innerHTML = text;
}
      } 
      if (window.innerWidth >= 1025) {
          if (index === currentIndex - 1 || index === currentIndex + 1) {
             if(logo) logo.style.opacity = "1"; 
          }
      }
    });
    const realIndex = (currentIndex - originalCount) % originalCount;
    const normalizedIndex = realIndex < 0 ? realIndex + originalCount : realIndex;
    dots.forEach((dot, idx) => {
      dot.classList.toggle('active', idx === normalizedIndex);
    });
  }
  function setSliderPosition() {
    track.style.transform = `translateX(${currentTranslate}px)`;
  }
  function dragStart(e) {
    if (isTransitioning) return;
    isDragging = true;
    startX = getPositionX(e);
    track.style.transition = 'none';
    track.style.cursor = 'grabbing';
    animationID = requestAnimationFrame(animation);
  }
  function dragEnd() {
    isDragging = false;
    cancelAnimationFrame(animationID);
    track.style.cursor = 'grab';
    const movedBy = currentTranslate - prevTranslate;
    if (movedBy < -100) {
      currentIndex++;
    } else if (movedBy > 100) {
      currentIndex--;
    }
    updateSlider(true);
  }
  function dragMove(e) {
    if (isDragging) {
      const currentX = getPositionX(e);
      currentTranslate = prevTranslate + currentX - startX;
    }
  }
  function getPositionX(e) {
    return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
  }
  function animation() {
    setSliderPosition();
    if (isDragging) requestAnimationFrame(animation);
  }
  track.addEventListener('mousedown', dragStart);
  track.addEventListener('mouseup', dragEnd);
  track.addEventListener('mouseleave', dragEnd);
  track.addEventListener('mousemove', dragMove);
  track.addEventListener('touchstart', dragStart, {passive: true});
  track.addEventListener('touchend', dragEnd);
  track.addEventListener('touchmove', dragMove, {passive: true});
  track.addEventListener('transitionend', () => {
    if (currentIndex >= originalCount * 2) {
      currentIndex = currentIndex - originalCount;
      updateSlider(false);
    }
    if (currentIndex < originalCount) {
      currentIndex = currentIndex + originalCount;
      updateSlider(false);
    }
    isTransitioning = false;
  });
  nextBtn.addEventListener('click', () => {
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex++;
    updateSlider(true);
  });
  prevBtn.addEventListener('click', () => {
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex--;
    updateSlider(true);
  });
  dots.forEach(dot => {
    dot.addEventListener('click', (e) => {
      if (isTransitioning) return;
      const targetIndex = parseInt(e.target.dataset.index);
      const realIndex = (currentIndex - originalCount) % originalCount;
      const normalizedCurrent = realIndex < 0 ? realIndex + originalCount : realIndex;
      currentIndex += (targetIndex - normalizedCurrent);
      updateSlider(true);
    });
  });
  window.addEventListener('resize', () => {
    setTimeout(() => updateSlider(false), 100);
  });
  track.style.cursor = 'grab';
  setTimeout(() => updateSlider(false), 100);
});

  } catch(e) { console.error(e); }
})();
})();
